import React from 'react';
import { Container } from 'typescript-ioc';
import { DateTimeFormatter } from '../../../../../../../infrastructure/implementations/date-formatter';
import { IAttendeeLiveSessionDTO } from '../../../../../../../api/control.dao';
import { getFullDateTimeStringInEventTimezone } from '../../../../../../../infrastructure/utils/date.util';
import Text from '../../../../../../global/text/text';
import { HighlightedSearchResult } from '../../../../shared/highlighted-search-result/highlighted-search-result';
import { OpenFrom } from '../../../../../../../tracking-service/tracking-values';
import { IRegistrant } from '../../participants-live-form/partisipants-live-form-registrants-tab.viewmodel';
import { AttendeeInfo } from '../../../../../../global/attendee-column/_attendee-info/_attendee-info';
import { AttendeeColumnPopoverViewmodel } from '../../../../../../global/attendee-column/attendee-column-popover/attendee-column-popover.viewmodel';
import { IAttendeeDetailsDTO, IAttendeeDTO } from '../../../../../../../api/attendees.dao';

interface IJoinedLiveListItemProps {
    attendee: IAttendeeLiveSessionDTO;
    eventTimezone: string;
}
export interface IRegistrantsLiveListItemProps {
    attendee: IRegistrant;
    searchQuery: string;
    meetingID: string;
    onAttendeeEditSaveCallback: (attendee: IAttendeeDetailsDTO) => void;
    attendeeDetailsPopoverVM: AttendeeColumnPopoverViewmodel;
}

const additionalAttendeeId = 'registrantsPopup';

const JoinedLiveListItem: React.FunctionComponent<IJoinedLiveListItemProps> = (props: IJoinedLiveListItemProps) => {
    const dateTimeFormatter = Container.get<DateTimeFormatter>(DateTimeFormatter);

    const {
        attendee,
        eventTimezone
    } = props;

    const {
        attendeeFirstLastName,
        organizationName,
        joinTime,
        leftTime
    } = attendee;

    const joinTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        joinTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimezone
    );
    const leftTimeInEventTimezone = leftTime ? dateTimeFormatter.dateToFormattedString(
        leftTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimezone
    ) : '';

    const fullStartDayTime = getFullDateTimeStringInEventTimezone(
        dateTimeFormatter,
        joinTime,
        eventTimezone,
        dateTimeFormatter.getLocalTimeFormat()
    );
    const fullLeftDayTime = leftTime ? getFullDateTimeStringInEventTimezone(
        dateTimeFormatter,
        leftTime,
        eventTimezone,
        dateTimeFormatter.getLocalTimeFormat()
    ) : '';

    return (
        <tr className='events-list-item'>
            <td>
                <Text message={attendeeFirstLastName} withEllipsis />
            </td>
            <td>
                <Text message={organizationName} withEllipsis />
            </td>
            <td>
                <Text message={joinTimeInEventTimezone} withEllipsis textTitle={fullStartDayTime} />
            </td>
            <td>
                <Text message={leftTimeInEventTimezone} withEllipsis textTitle={fullLeftDayTime} />
            </td>
        </tr>
    );
};

const RegistrantsLiveListItem: React.FunctionComponent<IRegistrantsLiveListItemProps> = (props: IRegistrantsLiveListItemProps) => {
    const {
        attendee,
        searchQuery,
        onAttendeeEditSaveCallback,
        attendeeDetailsPopoverVM,
        meetingID,
    } = props;

    return (
        <tr className='events-list-item'>
            <HighlightedSearchResult
                className='attendee-first-last-name'
            >
                <AttendeeInfo
                    attendee={attendee as IAttendeeDTO}
                    searchValue={searchQuery}
                    attendeeDetailsPopoverVM={attendeeDetailsPopoverVM}
                    withAttendeePopover={true}
                    additionalAttendeeId={meetingID + additionalAttendeeId}
                    openFrom={OpenFrom.RegistrantsListInParticipantPopup}
                    onAttendeeEditSaveCallback={onAttendeeEditSaveCallback}
                />
            </HighlightedSearchResult>
            <HighlightedSearchResult
                value={attendee.organizationName}
                searchQuery={searchQuery}
                wrapperTag='td'
            />
        </tr>
    );
};

export { JoinedLiveListItem, RegistrantsLiveListItem };